const themeStyles = colors => {
  const styles = {
    iconData: {
      height: 20,
      width: 20,
      margin: '18px 20px 0 0',
      fill: colors.iconGrey
    },
    iconBox: iconSize => {
      return {
        height: iconSize,
        width: iconSize,
        margin: '18px 20px 0 0',
        fill: colors.iconGrey
      }
    },
    dataTitleContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 1 100%',
      minWidth: 0
    },
    dataTitleAndDate: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    dataContainer: {
      display: 'flex',
      flexDirection: 'row',
      margin: '20px 16px 0px 19px',
      justifyContent: 'space-between',
      height: 66
    },
    bottomBorder: {
      borderBottom: `1px solid ${colors.placebo}`
    },
    dataTitle: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      color: colors.approxBlack,
      fontSize: 14,
      marginBottom: 6
    },
    dataSubTitle: {
      color: colors.secondaryGray,
      fontSize: '12px',
      lineHeight: '20px'
    },
    dateText: {
      color: colors.secondaryGray,
      fontSize: '12px',
      height: '100%'
    }
  }
  styles.dataContainerWithBorder = { ...styles.dataContainer, ...styles.bottomBorder }
  return styles
}

export default themeStyles
